import React from 'react';
import gql from 'graphql-tag'
import {useQuery} from "@apollo/client";
import Select from "react-select";
import {FormGroup} from "@blueprintjs/core";

const DIVISIONS_QUERY = gql`
    query {
        divisions {
            id
            name
            rank
        }
    }
`

const TEAMS_BY_DIVISION_QUERY = gql`
    query {
        seasonById(id: 4) {
            teams {
                id
                displayName: name
                division {
                    id
                    name

                    group {
                        rank
                    }

                    modifier {
                        rank
                    }
                }   
            }
        }
    }
`

export const DivisionsProvider = ({ children }) => {

  const {data, error} = useQuery(DIVISIONS_QUERY)

  if (error) return "Error!"

  return (
    <>
      {children({divisions: (data?.divisions ?? []).map(div => {
        return {
          value: div.id,
          label: div.name
        }
      })})}
    </>
  )
}

const TeamsInDivisionProvider = ({ division, children }) => {

  const {data, error} = useQuery(TEAMS_BY_DIVISION_QUERY)

  if (error) return "Error!"

  const allTeams = [...(data?.seasonById.teams ?? [])]
  allTeams.sort((a, b) =>
    (a.division.group.rank - b.division.group.rank) ||
    (a.division.modifier.rank - b.division.modifier.rank) ||
    a.displayName.localeCompare(b.displayName)
  )

  return (
    <>
      {children({teams: allTeams})}
    </>
  )
}

export const DivisionSelector = ({ onChange, disabled }) => {

  const [chosenDivision, setChosenDivision] = React.useState(null);

  return (
    <>
      <FormGroup
        label={'Choose Division'}
      >
        <DivisionsProvider>
          {({divisions}) => (
            <Select
              placeholder={divisions.length > 0 ? 'Select...' : 'Loading...'}
              options={divisions}
              value={chosenDivision}
              onChange={e => {
                setChosenDivision(e)
              }}
              isDisabled={disabled}
              isSearchable={false}
              blurInputOnSelect={true}
            />
          )}
        </DivisionsProvider>
      </FormGroup>

      {chosenDivision &&
        <TeamSelector
          division={chosenDivision.value}
          onChange={onChange}
        />
      }
    </>
  )
}

const TeamSelector = ({ division, onChange }) => {

  const [chosenTeam, setChosenTeam] = React.useState(null);

  React.useEffect(() => {
    setChosenTeam(null)
    onChange(null)
  }, [division, onChange])

  return (
    <FormGroup
      label={'Search & Select Team'}
    >
      <TeamsInDivisionProvider
        division={division}
      >
        {({teams}) => {
          return (
            <Select
              options={teams?.map(team => {
                return {
                  label: `${team.displayName} - ${team.division.name}`,
                  value: team.id,
                  meta: team
                }
              })}
              value={chosenTeam}
              onChange={e => {
                setChosenTeam(e)
                onChange(e.meta)
              }}
              blurInputOnSelect={true}
            />
          )
        }}
      </TeamsInDivisionProvider>
    </FormGroup>
  )
}

export const DropDownTeamSelector = ({ onChange, disabled }) => {
  return (
    <TeamSelector
      division={null}
      onChange={onChange}
    />
  )
}
